import {useRouter} from 'next/router';
import {useEffect, useState} from 'react';
import {isObjEmpty} from 'utils/helpers';

export interface IFilterType {
  filters?: string;
  ordering?: string;
  categorySlug?: string;
  promo_type?: string;
  products?: boolean;
}

interface UseFilterType {
  activeQueryParams: IFilterType | undefined;
  onChangeActiveFiltersList: (queryParams: IFilterType) => void;
}

export function useQueryFilters(): UseFilterType {
  const {push, query} = useRouter();
  const [activeQueryParams, setActiveQueryParams] = useState<IFilterType>(query);

  const helper = (queryParams: any) => {
    return Object.entries(queryParams)
      .filter((entry) => !!entry[1])
      .map((entry) => entry.join('='))
      .join('&');
  };

  useEffect(() => {
    if (activeQueryParams && !isObjEmpty(activeQueryParams)) {
      const activeQuery = helper(activeQueryParams);

      push(`${window.location.pathname}?${activeQuery}`);
    } else {
      push(`${window.location.pathname}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeQueryParams]);

  const onChangeActiveFiltersList = (queryParams: IFilterType) => {
    setActiveQueryParams({
      categorySlug: queryParams.categorySlug,
      ordering: queryParams.ordering,
      filters: queryParams.filters,
      promo_type: queryParams.promo_type,
      products: queryParams.products,
    });
  };

  return {
    activeQueryParams,
    onChangeActiveFiltersList,
  };
}
